module.exports = __webpack_public_path__ + "img/full3-min.009e3101.png";